import React, { memo } from 'react';
import { useMediaQuery } from 'react-responsive';

import IconLabel from '@fmbt/ui/IconLabel';
import { WarningIcon } from '@fmbt/ui/icons';
import DefaultModal, { DefaultModalProps } from 'components/atoms/DefaultModal';
import { red } from 'style/colour-palette';
import { MAX_WIDTH_MOBILE } from 'style/constants';

import './styles.less';

export interface WarningModalProps extends Pick<DefaultModalProps,
  | 'children'
  | 'confirmText'
  | 'dismissText'
  | 'isConfirmButtonDangerous'
  | 'isConfirmButtonLoading'
  | 'isOpen'
  | 'onConfirm'
  | 'onDismiss'
  | 'title'
  | 'width'
> { }

/**
 * A modal with a warning icon. Set isConfirmButtonDangerous to style the confirm
 * action as destructive (defaults to true).
 */
const WarningModal: React.NamedExoticComponent<WarningModalProps> = memo(
  ({
    title,
    children,
    width = 480,
    isConfirmButtonDangerous = true,
    ...rest
  }: WarningModalProps) => {
    const isMobile = useMediaQuery({ maxWidth: MAX_WIDTH_MOBILE });
    return (
      <DefaultModal
        {...rest}
        className="WarningModal"
        isConfirmButtonDangerous={isConfirmButtonDangerous}
        title={
          <IconLabel
            icon={<WarningIcon size={isMobile ? 28 : 24} color={red} />}
            label={title}
            gap={isMobile ? 10 : 12}
          />
        }
        width={width}
      >
        {children}
      </DefaultModal>
    );
  }
);

export default WarningModal;
